import { FormControl, FormGroup } from '@angular/forms';
import { IContact } from 'src/app/common/model/contacts.model';
import { ERecurrenceDuration } from 'src/app/common/model/util.model';
import { EItemType, ITax } from './item.model';

export enum EPOSLOCKSTATUS {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export interface ITransaction {
  transactionHeader: ITransactionHeader;
  transactionLineItems: ITransactionLineItem[];
  transactionDeliveryRecord?: ITransactionDeliveryRecord;
  transactionPaymentRecords: ITransactionPaymentRecord[];
}
export interface ITransactionHeader {
  _id?: string;
  createdAt?: string;
  transactionType?: ETransactionType;
  transactionDataCaptureSource?: ETransactionDataCaptureSource;
  transactionCode?: string;
  transactionTotalAmount?: number;
  convertedTransactionTotalAmount?: number;
  originalNonDiscountAmount?: number;
  convertedOriginalNonDiscountAmount?: number;
  transactionTotalCostAmount?: number;
  convertedTransactionTotalCostAmount?: number;
  transactionCurrency?: string;
  transactionPaidTotal?: number;
  transactionBalance?: number;
  convertedTransactionBalance?: number;
  transactionStatus?: ETransactionStatus;
  transactionDueDate?: string;
  customer?: IContact;
  transactionPaymentRecord?: ITransactionPaymentRecord;
  menuItems?: any[];
  transactionDate?: string;
  transactionTotalTax?: number;
  transactionTotalProfit?: number;
  convertedTransactionTotalProfit: number;
  currency: { symbol: string; code: string };
  customerNotes: string;
  transactionTotalamountWithtax?: number;
  transactionUniqueCode?: string;
  convertedAmount?: number;
  convertedTaxTotal?: number;
  conversionRate?: number;
  totalTaxes: ITax[];
  discount: {
    description: string;
    amount?: number;
    percentage?: number;
  };
  recurrenceSettings: {
    recurrenceDuration: ERecurrenceDuration;
    lastSentDate: string;
    nextSentDate: string;
    isActive: boolean;
    noOfDaysToNextNotification: number;
  };
}

export interface ITransactionPaymentRecord {
  createdAt?: string;
  transaction: string;
  referenceCode?: string;
  amount: number;
  paidInCurrencyAmount?: number;
  paidInCurrency?: string;
  conversionCurrencyConversionRate?: number;
  receiptDate?: string;
  notes?: string;
  paymentTerm?: string;
}

export interface ITransactionLineItem {
  _id?: string;
  item?: string;
  name: string | undefined;
  itemPrice: number;
  itemCost?: number;
  convertedItemPrice?: number;
  quantity: number;
  description?: string;
  itemPriceFromDB?: number;
  lineTotal?: number;
  convertedLineTotal?: number;
  taxes?: ITax[];
  isTaxed?: boolean;
  itemPriceWithTax?: number; // Ensure to make it mandatory
  image?: any;
  unitOfMeasure?: string;
  itemType?: EItemType;
  resourceBookingData?: {
    startTime: string;
    endTime: string;
  };
}

// export interface ICart {
//     item?: string;
//     _id?: string;
//     name?: string;
//     quantity?: number;
//     price?: number;
//     totalItems?: number;
//     totalAmount?: number;
// }

export enum PaymentTerm {
  CASH = 'CASH',
  MPESA = 'M-PESA',
  AIRTELMONEY = 'AIRTELMONEY',
  BANKDEPOSIT = 'BANKDEPOSIT',
  CARD = 'CARD',
  OTHER = 'OTHER',
  PAYPAL = 'PAYPAL',
  SKRILL = 'SKRILL',
  TCASH = 'T-CASH',
  PAYWITHEQUITY = 'PAYWITHEQUITY'
}

export enum ETransactionType {
  POS_SALE = 'POS_SALE',
  INVOICE = 'INVOICE',
  QUOTE = 'QUOTE',
  ORDER = 'ORDER',
  ONLINE_SHOP = 'ONLINE_SHOP',
  RESOURCE_BOOKING = 'RESOURCE_BOOKING'
}

export enum ETransactionDataCaptureSource {
  MOBILE = 'MOBILE',
  DESKTOP = 'DESKTOP',
  WEB = 'WEB'
}

export enum ETransactionStatus {
  DRAFT = 'DRAFT',
  PENDING = 'PENDING',
  PARTIALLYPAID = 'PARTIALLYPAID',
  PAID = 'PAID',
  APPROVED = 'APPROVED',
  CANCELLED = 'CANCELLED'
}

export enum EDeliveryStatus {
  PENDING = 'PENDING',
  DELIVERED = 'DELIVERED',
  RETURNED = 'RETURNED',
  NOTDELIVERED = 'NOTDELIVERED'
}

export interface ITransactionDeliveryRecord {
  _id?: string;
  transaction: string;
  deliveryStatus: EDeliveryStatus;
  deliveryCoordinates: {
    latitude: string;
    longitude: string;
  };
  customer: any;
  delivererDetails: any;
  deliveryNotes: string;
  deliveryStatusComment?: string;
  dateOfDelivery: Date;
}

export interface IInvoiceTransactionForm {
  customer: FormControl<IContact | null>;
  transactionDate: FormControl<string | null>;
  transactionDueDate: FormControl<string | null>;
  currency: FormControl<{ symbol: string; code: string } | null>;
  customerNotes: FormControl<string | null>;
  transactionTotalTax: FormControl<number | null>;
  transactionUniqueCode: FormControl<string | null>;
  conversionRate: FormControl<number | null>;
  discount: FormGroup<{
    description: FormControl<string | null>;
    amount: FormControl<number | null>;
    percentage: FormControl<number | null>;
  }>;
  discountType: FormControl<string | null>;
}

export interface ISaleTransactionTodayReports {
  expenseAmount: number;
  profitAmount: number;
  transactionAmount: number;
}
